// AboutUs.jsx



import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import Header from '../header/Header';
import AboutUsStyles from './AboutUs.styles';

const AboutUs = () => {
  return (
    <>
      <Header />

      {/* About Us Hero Section */}
      <Box sx={AboutUsStyles.heroSection}>
        <Typography variant="h3" component="h1" sx={AboutUsStyles.heroTitle}>
          About Tenant Guided Tours
        </Typography>
        <Typography variant="h6" component="p" sx={AboutUsStyles.heroSubtitle}>
          Automating Property Showings for a Seamless Leasing Experience
        </Typography>
      </Box>

      {/* Company Mission and Vision */}
      <Box sx={AboutUsStyles.missionSection}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper sx={AboutUsStyles.missionCard}>
              <Typography variant="h5" sx={AboutUsStyles.sectionTitle}>Our Mission</Typography>
              <Typography variant="body1" sx={AboutUsStyles.sectionText}>
                At Tenant Guided Tours, our mission is to simplify and automate property showings,
                allowing landlords and tenants to connect effortlessly. Our platform provides secure
                remote access and fully automated viewing experiences to streamline the leasing process.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={AboutUsStyles.visionCard}>
              <Typography variant="h5" sx={AboutUsStyles.sectionTitle}>Our Vision</Typography>
              <Typography variant="body1" sx={AboutUsStyles.sectionText}>
                We envision a world where finding a rental property is fast, easy, and efficient.
                Through cutting-edge technology and exceptional service, we aim to transform the
                property rental experience for everyone involved.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* Services Overview */}
      <Box sx={AboutUsStyles.servicesSection}>
        <Typography variant="h4" sx={AboutUsStyles.sectionTitle}>Our Services</Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Paper sx={AboutUsStyles.serviceCard}>
              <Typography variant="h6" sx={AboutUsStyles.serviceTitle}>Remote Access</Typography>
              <Typography variant="body1" sx={AboutUsStyles.serviceText}>
                With our secure remote access, potential tenants can view properties at their convenience,
                reducing scheduling conflicts and ensuring a smooth experience.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={AboutUsStyles.serviceCard}>
              <Typography variant="h6" sx={AboutUsStyles.serviceTitle}>Automated Showings</Typography>
              <Typography variant="body1" sx={AboutUsStyles.serviceText}>
                Our platform automates the entire showing process, from scheduling to access, allowing
                landlords and agents to save time and focus on what matters most.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={AboutUsStyles.serviceCard}>
              <Typography variant="h6" sx={AboutUsStyles.serviceTitle}>Tenant Screening</Typography>
              <Typography variant="body1" sx={AboutUsStyles.serviceText}>
                We offer built-in screening tools to help landlords find reliable tenants, ensuring a
                better match for both parties.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* Our Values Section */}
      <Box sx={AboutUsStyles.valuesSection}>
        <Typography variant="h4" sx={AboutUsStyles.sectionTitle}>Our Core Values</Typography>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={4}>
            <Paper sx={AboutUsStyles.valueCard}>
              <Typography variant="h6" sx={AboutUsStyles.valueTitle}>Innovation</Typography>
              <Typography variant="body2" sx={AboutUsStyles.valueText}>
                We are dedicated to using the latest technology to make property leasing easier, faster, 
                and more convenient for landlords and tenants alike.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={AboutUsStyles.valueCard}>
              <Typography variant="h6" sx={AboutUsStyles.valueTitle}>Transparency</Typography>
              <Typography variant="body2" sx={AboutUsStyles.valueText}>
                We believe in open communication and provide clear information at every step, ensuring
                both landlords and tenants have confidence in our process.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper sx={AboutUsStyles.valueCard}>
              <Typography variant="h6" sx={AboutUsStyles.valueTitle}>Customer Focus</Typography>
              <Typography variant="body2" sx={AboutUsStyles.valueText}>
                Our customers are at the heart of everything we do. We strive to exceed their expectations
                through exceptional service and support.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

    </>
  );
};

export default AboutUs;
